import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
  nisseirenWork: {},
  junseiBuhin: {},
};
const actions: ActionTree<any, any> = {
  setNisseirenWorkStoreByKatashiki({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setNisseirenWorkStoreByKatashiki", payload);
  },
  setJunseiBuhinStoreByKatashiki({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setJunseiBuhinStoreByKatashiki", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setNisseirenWorkStoreByKatashiki(state: any, payload: any) {
    const arrayKeys: Array<string | number> = [
      payload.katashiki,
      payload.engineKatashiki,
      payload.kakyukiKbn, // number
      payload.uketsukeExtendsId, // number
      payload.sknInspectDescriptionId];
    // 多階層のnisseirenWorkの存在チェック
    // state.nisseirenWork[katashiki][engineKatashiki][kakyukiKbn][uketsukeExtendsId][sknInspectDescriptionId]
    if ( !nestedArrayCheck( state.nisseirenWork , arrayKeys , true ) || arrayKeys.length != 5 ) {
      return;
    } else {
      state.nisseirenWork[arrayKeys[0]][arrayKeys[1]][arrayKeys[2]][arrayKeys[3]][arrayKeys[4]] = payload.nisseirenWork;
    }
  },
  setJunseiBuhinStoreByKatashiki(state: any, payload: any) {
    const arrayKeys: string[] = [
      payload.katashikiShiteiNo,
      payload.ruibetsuKubunNo,
      payload.katashiki,
      payload.engineKatashiki,
      payload.syaryouShiki,
      payload.syaryouShuki,
      payload.sknInspectDescriptionId];
    // 多階層のjunseiBuhinの存在チェック
    // state.junseiBuhin[型式指定番号][類別区分番号][型式][エンジン型式][車両始期][車両終期][点検項目ID]
    if ( !nestedArrayCheck( state.junseiBuhin , arrayKeys , true ) || arrayKeys.length != 7 ) {
      return;
    } else {
      const parent = arrayKeys.slice(0, -1).reduce(
        (result: any, key: string) => result[key], state.junseiBuhin);
      parent[arrayKeys[arrayKeys.length - 1]] = payload.junseiBuhin;
    }
  },
  clearState(state: any) {
    Object.assign(state, { ...initialState },);
  }
};

const getters: GetterTree<any, any> = {
  getNisseirenWorkStoreByKatashiki: (state: any) => (arrayKeys: Array<string | number>) => {
    // 多階層のnisseirenWorkの存在チェック
    // state.nisseirenWork[katashiki][engineKatashiki][kakyukiKbn][uketsukeExtendsId][sknInspectDescriptionId]
    if ( !nestedArrayCheck(state.nisseirenWork, arrayKeys, false) || arrayKeys.length != 5 ) {
      return;
    }
    return state.nisseirenWork[arrayKeys[0]][arrayKeys[1]][arrayKeys[2]][arrayKeys[3]][arrayKeys[4]];
  },
  getJunseiBuhinStoreByKatashiki: (state: any) => (arrayKeys: Array<string | number>) => {
    // 多階層のjunseiBuhinの存在チェック
    // state.junseiBuhin[型式指定番号][類別区分番号][型式][エンジン型式][車両始期][車両終期][点検項目ID]
    if ( !nestedArrayCheck(state.junseiBuhin, arrayKeys, false) || arrayKeys.length != 7 ) {
      return;
    }
    const junseiBuhin = arrayKeys.reduce(
      (result: any, key: string | number) => result[key], state.junseiBuhin);
    return responseArray(junseiBuhin);
  },
};

// 多階層のnisseirenWorkの存在チェック(再帰関数)
function nestedArrayCheck( targetObject: any, arrayKeys: Array<string | number>, runInitialize: boolean ): boolean {
  if ( !arrayKeys || arrayKeys.length == 0 || arrayKeys[0] === null || arrayKeys[0] === undefined ) {
    return false;
  } else {
    if ( !targetObject[arrayKeys[0]] ) {
      // 存在しない場合、初期化をするか、失敗判定を返す
      if ( runInitialize ) {
        targetObject[arrayKeys[0]] = {};
      } else {
        return false;
      }
    }
    // 最下層ならチェックを終了し、違うなら次の下層へ進む
    if ( arrayKeys.length == 1 ) {
      return true;
    } else {
      return nestedArrayCheck( targetObject[arrayKeys[0]], arrayKeys.slice(1), runInitialize );
    }
  }
}

function responseArray(items: any) {
  // 連想配列(Object型)になっているので配列にして返す
  let junseiBuhinArray: any = [];
  junseiBuhinArray = Object.keys(items).map((key) => {
    // return [Number(key), obj[key]];
    return items[key];
  });
  return junseiBuhinArray;
}

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
